import {useEffect} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import AppConfig from "../../services/AppConfig";
import Analytics from "../../services/Common/Analytics/Analytics";
import { run, acceptCategory, hide } from 'vanilla-cookieconsent';
import {useTranslation} from "react-i18next";
import {TFunctionNonStrict} from "i18next";

interface Props {
     path:string
}
const CookiesAlert = (props:Props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const {t, i18n} = useTranslation();
    const languages = ["pl", "en"];

    const removeQueryParam = async (paramKey:any) => {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.delete(paramKey);

        navigate({
            search: searchParams.toString(),
        }, { replace: true });
    }

    const getTranslationsKeys = (t:  TFunctionNonStrict<"translation">) => {
        return {
            consentModal: {
                title: t("modules.cookies.field.consent_modal_header.title"),
                description: t("modules.cookies.field.consent_modal_header.description"),
                acceptAllBtn: t("modules.cookies.action.accept_all.title"),
                showPreferencesBtn: t("modules.cookies.action.adjust.title"),
            },
            preferencesModal: {
                title: t("modules.cookies.field.preferences_modal_header.title"),
                acceptAllBtn: t("modules.cookies.action.accept_all.title"),
                acceptNecessaryBtn: t("modules.cookies.action.reject_all.title"),
                savePreferencesBtn: t("modules.cookies.action.accept_selected.title"),
                closeIconLabel: t("common.action.close"),
                sections: [
                    {
                        title: t("modules.cookies.field.necessary_cookies.title"),
                        description: t("modules.cookies.field.necessary_cookies.description"),
                        linkedCategory: 'necessary'
                    },
                    {
                        title: t("modules.cookies.field.analytical_cookies.title"),
                        description: t("modules.cookies.field.analytical_cookies.description"),
                        linkedCategory: 'analytics'
                    },
                    {
                        title: t("modules.cookies.field.marketing_cookies.title"),
                        description:  t("modules.cookies.field.marketing_cookies.description"),
                        linkedCategory: 'marketing'
                    }
                ]
            }
        }
    }

    const initCookies = async () => {
        let urlSearchParams = new URLSearchParams(location.search);
        let acceptedCookie = urlSearchParams.get("cookie_accepted");
        let path = props.path;
        if (path && path !== "/") {
            if (path.endsWith('/')) {
                path = path.slice(0, -1);
            }
        } else {
            path = "/";
        }
        if(!acceptedCookie && AppConfig.isWidget()){
            return;
        }
        await run({
            cookie: {
                path: path,
            },
            onConsent: ({cookie}) => {
                Analytics.updateConsent();
            },
            disablePageInteraction: true,
            guiOptions: {
                consentModal: {
                    layout: 'box wide',
                    position: 'middle center'
                }
            },
            categories: {
                necessary: {
                    enabled: true,  // this category is enabled by default
                    readOnly: true  // this category cannot be disabled
                },
                analytics: {},
                marketing: {
                    // enabled: false,
                    // readOnly: false,
                }
            },

            language: {
                default: i18n.language || 'pl',
                translations: Object.fromEntries(
                    languages.map(lang => {
                        const fixedT = i18n.getFixedT(lang);
                        return [lang, getTranslationsKeys(fixedT)];
                    })
                )
            }
        });
        if (acceptedCookie) {
            let acceptCookieCategories = acceptedCookie.split(",");
            acceptCategory(acceptCookieCategories);
            hide();
            removeQueryParam("cookie_accepted");
        }
    }
    useEffect(() => {
        if (!i18n.isInitialized) return;

        initCookies();
    }, [i18n.isInitialized]);

    return null;
}
export default CookiesAlert;